<script lang="ts" setup>
interface Props {
  title: string
  description?: string
  align?: 'left' | 'center' | 'right'
  size?: 'md' | 'lg' // New size variant
}

const props = withDefaults(defineProps<Props>(), {
  align: 'center',
  description: '',
  size: 'lg' // Default to Large
})
</script>

<template>
  <div 
    class="section-title" 
    :class="[`text-${props.align}`, `is-${props.size}`]"
  >
    <h2 class="section-title__title">
      {{ props.title }}
    </h2>
    <p v-if="props.description" class="section-title__description">
      {{ props.description }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.section-title {
  width: 100%;
  margin: 0 auto;
  font-family: 'Apple SD Gothic Neo', sans-serif;

  &.text-center { text-align: center; }
  &.text-left { text-align: left; }
  &.text-right { text-align: right; }

  &__title {
    color: #211F1F;
    font-weight: 700;
    line-height: 1.2;
    font-family: 'Apple SD Gothic Neo', sans-serif;
   
  }

  &__description {
      @include vwUnit('margin-top', 12, 8);
      color: #404040;
      font-weight: 400;
  }

  &.is-lg {
    .section-title__title {
      @include vwUnit('font-size', 53.3, 53);

    }
    .section-title__description {
      @include vwUnit('font-size', 20, 16);
    }
  }

  &.is-md {
    .section-title__title {
      @include vwUnit('font-size', 40, 32); // Smaller Desktop & Mobile sizes
    }
    .section-title__description {
      @include vwUnit('font-size', 18, 14);
    }
  }
}
</style>
